import React, { useCallback } from 'react'
import { Input, Button, Row, Col } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import BackButton from '../BackButton'
import './ListPageHeader.styles.css'

interface ListPageHeaderProps {
  title: string
  subtitle: string
  searchPlaceholder: string
  searchValue: string
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  createButtonText: string
  onCreateClick: () => void
  loading?: boolean
  showBackButton?: boolean
}

export const ListPageHeader: React.FC<ListPageHeaderProps> = ({
  title,
  subtitle,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  createButtonText,
  onCreateClick,
  loading = false,
  showBackButton = false
}) => {
  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e)
  }, [onSearchChange])

  return (
    <div className="list-page-header">
      <div className="list-page-header-content">
        <div className="list-page-header-left">
          {showBackButton && <BackButton />}
          <div>
            <h1 className="list-page-title">
              {title}
            </h1>
            <p className="list-page-subtitle">
              {subtitle}
            </p>
          </div>
        </div>
        <div className="list-page-search-controls">
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={24} md={24} lg={14} xl={16}>
              <Input
                placeholder={searchPlaceholder}
                value={searchValue}
                onChange={handleSearchChange}
                size="large"
                className="list-page-search-input"
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={10} xl={8} className="list-page-create-button-col">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={onCreateClick}
                className="list-page-create-button"
                size="large"
                disabled={loading}
              >
                {createButtonText}
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}
